import type { Slots } from '@/lib/request/types/timesheet';
import { BreakState } from '@/stores/timesheets';
import { DateTime } from 'luxon';

export function getLateMinutes(rosterStartTime: number): number | undefined {
  const now = DateTime.now().toSeconds();
  const MAX_LATE_TIME = 3660;

  if (
    Math.round(rosterStartTime - now) < 0 &&
    Math.round(now - rosterStartTime) < MAX_LATE_TIME
  ) {
    return Math.ceil((rosterStartTime - now) / 60) * -1;
  }
}

export function getBreakStartingSoonMinutes(
  breaks: Slots[]
): number | undefined {
  const now = DateTime.now().toSeconds();
  const STARTS_WITHIN_MINUTES = 15;

  for (const slot of breaks) {
    const startsInSeconds = Math.round(slot.intUnixStart - now);
    if (startsInSeconds >= 0 && startsInSeconds <= STARTS_WITHIN_MINUTES * 60) {
      return Math.floor(startsInSeconds / 60);
    }
  }
}

export function getBreakLateMinutes(breaks: Slots[]): number | undefined {
  const now = DateTime.now().toSeconds();
  const MAX_LATE_MINUTES = 5;
  for (const slot of breaks) {
    if (
      slot.strState === BreakState.NotStart &&
      Math.round(slot.intUnixStart - now) < 0 &&
      now - slot.intUnixStart < MAX_LATE_MINUTES * 60
    ) {
      return Math.ceil((slot.intUnixStart - now) / 60) * -1;
    }
  }
}

export function getBreakEndingSoonMinutes(breaks: Slots[]): number | undefined {
  const now = DateTime.now().toSeconds();
  const ENDS_WITHIN_MINUTES = 5;

  for (const slot of breaks) {
    const EndsInSeconds = Math.round(slot.intUnixEnd - now);
    if (
      slot.strState === BreakState.InProgress &&
      EndsInSeconds >= 0 &&
      EndsInSeconds <= ENDS_WITHIN_MINUTES * 60
    ) {
      return Math.round(Math.floor(EndsInSeconds / 60));
    }
  }
}

export function getBreakOverTimeMinutes(breaks: Slots[]): number | undefined {
  const now = DateTime.now().toSeconds();
  for (const slot of breaks) {
    const EndedSecondsAgo = Math.round(now - slot.intUnixEnd);
    if (
      slot.strState === BreakState.InProgress &&
      slot.intUnixEnd &&
      EndedSecondsAgo > 0
    ) {
      return Math.ceil(EndedSecondsAgo / 60);
    }
  }
}

export function getOnBreakMinutes(breaks: Slots[]): number | undefined {
  const now = DateTime.now().toSeconds();
  for (const slot of breaks) {
    if (slot.strState === BreakState.InProgress) {
      const startedSecondsAgo = Math.round(now - slot.intUnixStart);
      if (startedSecondsAgo >= 0) {
        return Math.floor(startedSecondsAgo / 60);
      }
    }
  }
}

export function getStartingSoonMinutes(
  rosterStartTime: number
): number | undefined {
  const now = DateTime.now().toSeconds();
  const STARTS_WITHIN_MINUTES = 15;

  const startsInSeconds = Math.round(rosterStartTime - now);
  if (startsInSeconds >= 0 && startsInSeconds <= STARTS_WITHIN_MINUTES * 60) {
    return Math.ceil(startsInSeconds / 60);
  }
}

export function getEndingSoonMinutes(endtime: number): number | undefined {
  const now = DateTime.now().toSeconds();
  const ENDS_WITHIN_MINUTES = 15;

  const EndsInSeconds = Math.round(endtime - now);
  if (EndsInSeconds >= 0 && EndsInSeconds <= ENDS_WITHIN_MINUTES * 60) {
    return Math.ceil(EndsInSeconds / 60);
  }
}

export function getOverTimeMinutes(endtime: number): number | undefined {
  const now = DateTime.now().toSeconds();
  const OVERTIME_LIMIT_HOURS = 6;

  if (endtime < now) {
    const overTimeMinutes = Math.floor((now - endtime) / 60);
    if (overTimeMinutes < OVERTIME_LIMIT_HOURS * 60 && overTimeMinutes > 0) {
      return overTimeMinutes;
    }
  }
}
